import { render, staticRenderFns } from "./PtzCameraControllerTemplate.vue?vue&type=template&id=1d218260&scoped=true&"
import script from "./PtzCameraControllerTemplate.vue?vue&type=script&lang=js&"
export * from "./PtzCameraControllerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PtzCameraControllerTemplate.vue?vue&type=style&index=0&id=1d218260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d218260",
  null
  
)

export default component.exports